"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExtendedPropertyType;
(function (ExtendedPropertyType) {
    ExtendedPropertyType["scenario"] = "scenario";
    ExtendedPropertyType["portfolio"] = "portfolio";
    ExtendedPropertyType["portfolioEntity"] = "portfolioEntity";
    ExtendedPropertyType["scenarioManager"] = "scenarioManager";
})(ExtendedPropertyType = exports.ExtendedPropertyType || (exports.ExtendedPropertyType = {}));
//# sourceMappingURL=ExtendedPropertyType.js.map